import Layout from "Components/Layouts/Common/common";
import ScrollToTop from "react-scroll-to-top";
import { IoIosArrowUp } from "react-icons/io";
import About from "Components/Home/About/about";
import Slider from "Components/Home/Slider/Slider";
import Assistance from "Components/Home/Assistance/Assistance";
import Slidertwo from "Components/Home/Slidertwo/Slider";
import Cards from "Components/Home/Cards/Cards";
import Process from "Components/Home/process/Cards";
import Services from "Components/Home/Services/Services";
import Poster from "Components/Home/Poster/Poster";
import Payroll from "Components/Home/Payroll/Payroll";
function Homepage() {
    return (
        <Layout>
            {/*    <ScrollToTop
                smooth
                // color=""

                component={<IoIosArrowUp color="white" size={28} />}
                style={{ borderRadius: "10px", backgroundColor: "#04cef0" }}
            /> */}
            <Slider />
            <Process />
            <Assistance />
            <Payroll />
            <Cards />
            <About />
            <Slidertwo />
            <Poster />
        </Layout>
    );
}

export default Homepage;
